import React, { useContext } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import AppContext from '../../App/context'
import Form from '../../Form'

import style from './style.css'
import AccountContext from '../context'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'

function ForgotPassword(props) {

    const {
        SubmitProps = {}
    } = props

    const accountContext = useContext(AccountContext)
    const { user, name } = accountContext

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)
    const utils = getUtils(context)

    const { wapp } = context

    async function onSubmit(e, formData) {
        return await utils.sendRequest({ requestName: name + 'ForgotPassword', args: formData, redirect: null })
    }

    let formDataFromResolvers = {}
    try {
        formDataFromResolvers = utils.getGlobalState('res.graphql.mutation.' + name + 'ForgotPassword.formData')
    } catch (e) {
    }

    const formData = {
        ...formDataFromResolvers,
        submit: {
            label: appContext.labels.forgotPasswordSubmitLabel,
            fullWidth: true,
            ...SubmitProps
        }
    }

    if (user?._id) {
        formData.email.value = user.email
        formData.email.disabled = true
        formData.email.hidden = true
    }

    formData['record.col1'] = {
        isContainer: true,
        hiddenContainer: true
    }

    formData['email'].transformValue = (value) => {
        if (value) {
            value = value.trim()
        }
        return value
    }
    formData['email'].enableUpdateValueAfterTransform = true

    wapp.styles.use(style)

    return (
        <div className={style.forgotPassword}>
            {
                <Typography className={style.forgotPasswordInfo} variant={'h6'}
                            weight={600}>{appContext.messages.forgotPasswordInfo}</Typography>
            }
            <Form
                formData={formData}
                onSubmit={onSubmit}
                successMessage={
                    appContext.messages.forgotPasswordSuccessMessage
                }
            />
        </div>
    )
}

export default withWapp(ForgotPassword)
